module.exports = __webpack_public_path__ + "static/media/shops_2x.fa76fc06.png";